import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { Dialog } from 'src/app/shared/models/app-models/Dialog.model';
import { inject } from '@angular/core/testing';
import { ShareDataService } from '../../services/share-data.service';
import { WorkflowOfficer } from 'src/app/shared/models/database-models';
import { BackendApiService } from '../../../core/services/backend-api';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-forward-dialog',
  templateUrl: './forward-dialog.component.html',
  styleUrls: ['./forward-dialog.component.scss'],
})
export class ForwardDialogComponent implements OnInit {
  officerList!: WorkflowOfficer[];
  selected: string | undefined;
  forwardInfo: any;
  isErr: boolean = false;

  constructor(
    public dialogInfoRef: MatDialogRef<DialogComponent>,
    private sharedService: ShareDataService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private BackendApi: BackendApiService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {
    this.officerList = this.data.officerList;
    this.forwardInfo = this.data.forwardInfo;
  }

  ngOnInit(): void {}

  close(): void {
    this.isErr = false;
    this.dialogInfoRef.close();
  }

  openSnackBar(notifMsg: string) {
    this._snackBar.open(notifMsg, undefined, {
      verticalPosition: "top",
      panelClass: 'item-vendor-dialog',
      duration: 3000
    });
  }

  forwardToUser() {
    if (!this.selected) {
      this.isErr = true;
    } else {
      const body = {
        StatusCode: this.forwardInfo.statusCode,
        Dag_run_id: this.forwardInfo.dragId,
        MPDocumentNumber: this.forwardInfo.documentNo,
        Actioner: this.forwardInfo.actioner,
        ForwardedUser: this.selected,
      };
      this.BackendApi.forwardToUser(body).subscribe((val) => {
        this.close();
        this.openSnackBar('Document forwarded')
        this.router.navigateByUrl('/worklist')
      });
    }
  }
}
